enum TrackingType {
  NONE = '',
  // NONE = '0',
  CJ = '1',
  CB = '2',
  OLA = '3',
  DP = '4',
  PZ = '5',
}

export { TrackingType };
